<script setup lang="ts">
import SelectSimple from '@/components/common/selects/SelectSimple.vue'

interface Company {
  id: string
  value: string | boolean | number
  label: string
}

defineProps({
  uniqueCompanies: {
    type: Array as () => Company[],
    default: () => [],
  },
})

const modelValue = defineModel<string>()
</script>

<template>
  <SelectSimple v-model="modelValue" :options="uniqueCompanies" />
</template>
